import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Checkbox, Col, Form, Row, Spin } from 'antd';
import { useState } from 'react';
import useStore from '../../../../store';
import { accommodationRequest } from '../../../../request/AuthRequest';
import { displayFormats } from '../../../../config/Global';
import React from 'react';
import RichEditor from '../../../../component/wysuwygEditor';
import QuillEditor from '../../../../component/QuillEditor';
import FAQForm from '../../Temples/components/FAQComponent';

const PropertyComponent = observer((props) => {
	const {
		handleChange,
		onFinish,
		id,
		form,
		initialValues,
		descriptionValue,
		setDescriptionValue,
		// testBlurEv,
		addModel,
		// isChecked,
		// setIsChecked,
	} = props;
	const [stateLoading, setStateLoading] = useState(true);
	const [propertyAmenityLoading, setPropertyAmenityLoading] = useState(true);
	const [roomAmenityLoading, setRoomAmenityLoading] = useState(true);
	const [cityLoading, setCityLoading] = useState(true);
	const [propertyLoading, setpropertytypeLoading] = useState(true);
	const [TDSTypeLoading, setTDSTypeLoading] = useState(true);
	const [roomLoading, setRoomLoading] = useState(true);

	const {
		AUTH: {
			stateList,
			cityList,
			lookupKeyList,
			amenityList,
			getStateList,
			getCityList,
			getAllByLookupKeyList,
			getAmenityList,
		},
		ACCOMMODATION: { roomCategoryDetail, propertyDetail },
	} = useStore();

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
			onChange={handleChange}
			initialValues={initialValues}
		>
			<Row gutter={24}>
				<Col span={6}>
					<InputComponent
						required
						name="propertyName"
						label="Property Name"
						placeholder="Enter Property Name"
						onChange={handleChange}
						rules={accommodationRequest.propertyName}
					// onBlur={() => {
					// 	if (isChecked) {
					// 		testBlurEv();
					// 	}
					// }}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eStateId"
						label="Select State"
						placeholder="Select State"
						onFocus={() =>
							stateLoading &&
							getStateList().then(() => setStateLoading(false))
						}
						disabled={addModel == 'edit' ? true : false}
						notFoundContent={
							stateLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(stateList.length && stateList) ||
								(propertyDetail && [
									{
										eRegionId:
											propertyDetail &&
											propertyDetail.eStateId &&
											propertyDetail.eStateId,
										regionName:
											propertyDetail &&
											propertyDetail.stateName &&
											propertyDetail.stateName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							form.resetFields(['eCityId']);
							setCityLoading(true);
							handleChange();
							// if (isChecked) {
							// 	testBlurEv();
							// }
						}}
						rules={accommodationRequest.state}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						// onBlur={() => {
						// 	if (isChecked) {
						// 		testBlurEv();
						// 	}
						// }}
						type="select"
						showSearch={true}
						name="eCityId"
						label="Select City"
						placeholder="Select City"
						onFocus={() =>
							cityLoading &&
							getCityList(form.getFieldValue('eStateId')).then(
								() => setCityLoading(false)
							)
						}
						disabled={addModel == 'edit' ? true : false}
						notFoundContent={
							cityLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(cityList.length && cityList) ||
								(propertyDetail && [
									{
										eRegionId:
											propertyDetail &&
											propertyDetail.eCityId &&
											propertyDetail.eCityId,
										regionName:
											propertyDetail &&
											propertyDetail.cityName &&
											propertyDetail.cityName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							handleChange();
							// if (isChecked) {
							// 	testBlurEv();
							// }
						}}
						rules={accommodationRequest.city}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						// required
						name="pinCode"
						label="Pin Code"
						placeholder="Enter Pin Code"
						onChange={handleChange}
						rules={accommodationRequest.pinCode}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="contactNo"
						label="Phone Number"
						placeholder="Enter Phone Number"
						onChange={handleChange}
						rules={accommodationRequest.contactNo}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						// onBlur={() => {
						// 	if (isChecked) {
						// 		testBlurEv();
						// 	}
						// }}
						name="propertyType"
						label="Select Property Type"
						placeholder="Select Property Type"
						onFocus={() =>
							propertyLoading &&
							getAllByLookupKeyList(
								'lookupKey=PROPERTYTYPE&isAdmin=false'
							).then((data) => setpropertytypeLoading(data))
						}
						disabled={addModel == 'edit' ? true : false}
						onChange={handleChange}
						options={{
							values:
								propertyLoading && propertyLoading.length
									? propertyLoading
									: propertyDetail && [
										{
											lookupIntValue:
												propertyDetail.propertyType,
											lookupValue:
												propertyDetail.propertyTypeName,
										},
									],
							value_key: 'lookupIntValue',
							text_key: 'lookupValue',
						}}
						notFoundContent={
							propertyLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						allowClear
						rules={accommodationRequest.propertyType}
					/>
				</Col>
				<Col span={6}>
					{/* <InputComponent
						required
						type="time_picker"
						name="time"
						label="Check-In-Out Time"
						placeholder="Select Check-In-Out Time"
						onChange={handleChange}
						allowClear={false}
						format={displayFormats.TIME_FORMAT}
						rules={accommodationRequest.time}
					/> */}

					<InputComponent
						required
						type="time"
						name="checkIn"
						label="Check-In-Time"
						placeholder="Select Check-In Time"
						use12Hours
						onChange={handleChange}
						allowClear={false}
						format={'h:mm:ss A'}
						needConfirm={false}
						rules={accommodationRequest.checkIn}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="time"
						name="checkOut"
						label="Check-Out-Time"
						placeholder="Select Check-Out Time"
						use12Hours
						onChange={handleChange}
						allowClear={false}
						format={'h:mm:ss A'}
						needConfirm={false}
						rules={accommodationRequest.checkOut}
					/>
				</Col>
				<Col span={24}>
					<Row gutter={24}>
						<Col span={12}>
							<Row gutter={24}>
								<Col span={12}>
									<InputComponent
										required
										name="address"
										label="Address"
										placeholder="Enter Address"
										onChange={handleChange}
										rules={accommodationRequest.address}
									/>
								</Col>
								<Col span={12}>
									<InputComponent
										// required
										name="rating"
										label="Rating"
										placeholder="Enter Rating"
										onChange={handleChange}
										rules={accommodationRequest.rating}
									/>
								</Col>
								<Col span={24}>
									<InputComponent
										required
										type="select"
										mode="multiple"
										showSearch={true}
										name="eAmenityId"
										label="Select Amenity"
										placeholder="Select Amenity"
										onFocus={() => {
											propertyAmenityLoading &&
												getAmenityList('2').then(() =>
													setPropertyAmenityLoading(
														false
													)
												);
										}}
										notFoundContent={
											propertyAmenityLoading ? (
												<Spin size="small" />
											) : (
												'No Data Found'
											)
										}
										options={{
											values:
												(amenityList.length &&
													amenityList) ||
												(propertyDetail &&
													propertyDetail.propertyAmenityViewModel &&
													propertyDetail
														.propertyAmenityViewModel
														.length &&
													propertyDetail.propertyAmenityViewModel),
											value_key: 'eAmenityId',
											text_key: 'amenityName',
										}}
										onChange={handleChange}
										rules={accommodationRequest.amenity}
									/>
								</Col>
							</Row>
						</Col>
						<Col span={12} rowSpan={2}>
							{/* <InputComponent
							// required
							type="textarea"
							name="description"
							label="Description"
							placeholder="Enter Description"
							onChange={handleChange}
							//rules={accommodationRequest.description}
						/> */}
							<label class="ant-form-item-required" title="Description">Description</label>
							<QuillEditor
								value={descriptionValue}
								onChange={(val) => setDescriptionValue(val)}
							/>
							{/* <RichEditor
								label={'Description'}
								defaultValue={descriptionValue}
								onChange={setDescriptionValue}
							/> */}
						</Col>
					</Row>
					{/* <Row gutter={24}>
						{/* <Col span={12}>
							<Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
								Want to add meta data
							</Checkbox>
						</Col> */}
					{/* {isChecked && ( */}
					<>
						<Col span={24}>
							<Row gutter={24}>
								<Col span={6}>
									<InputComponent
										required
										name="metaTitle"
										label="Meta Title"
										placeholder="Enter Meta Title"
										onChange={handleChange}
										rules={
											accommodationRequest.metaTitle
										}
									/>
								</Col>
								<Col span={6}>
									<InputComponent
										required
										name="metaKeywords"
										label="Meta Keywords"
										placeholder="Enter MetaKey Words"
										onChange={handleChange}
										rules={
											accommodationRequest.metaKeywords
										}
									/>
								</Col>
								{/* <Col span={24}>
											<InputComponent
												required
												name="shortName"
												label="ShortName"
												placeholder="Enter Short Name"
												onChange={handleChange}
												rules={
													accommodationRequest.shortName
												}
											/>
										</Col> */}
								<Col span={12}>
									<InputComponent
										required
										style={{ height: '30px' }}
										type={'textarea'}
										name="metaDescription"
										label="Meta Description"
										placeholder="Enter Meta Description"
										onChange={handleChange}
										rules={
											accommodationRequest.metaDescription
										}
									/>
								</Col>
							</Row>
						</Col>
					</>
					{/* )} */}
					<Col span={24}>
						<Row gutter={24}>
							<Col span={6}>
								<InputComponent
									required
									name="shortName"
									label="Short Name"
									placeholder="Enter Short Name"
									onChange={handleChange}
									rules={accommodationRequest.shortName}
								/>
							</Col>
							<Col span={6}>
								<InputComponent
									required
									type="select"
									// onBlur={() => {
									// 	if (isChecked) {
									// 		testBlurEv();
									// 	}
									// }}
									name="tdsCategory"
									label="Select TDS Category"
									placeholder="Select TDS Category"
									onFocus={() =>
										TDSTypeLoading &&
										getAllByLookupKeyList(
											'lookupKey=TDSCATEGORY&isAdmin=false'
										).then((data) => setTDSTypeLoading(data))
									}
									// disabled={addModel == 'edit' ? true : false}
									onChange={handleChange}
									options={{
										values:
											TDSTypeLoading && TDSTypeLoading.length
												? TDSTypeLoading
												: propertyDetail && [
													{
														lookupIntValue:
															propertyDetail.tdsCategory,
														lookupValue:
															propertyDetail.tdsCategoryName,
													},
												],
										value_key: 'lookupIntValue',
										text_key: 'lookupValue',
									}}
									notFoundContent={
										propertyLoading ? (
											<Spin size="small" />
										) : (
											'No Data Found'
										)
									}
									allowClear
									rules={accommodationRequest.TDSType}
								/>
							</Col>
							<Col span={6}>
								<InputComponent
									required={![3, 4].includes(form.getFieldValue('tdsCategory'))}
									name="pan"
									label="PAN Number"
									placeholder="Enter PAN Number"
									onChange={handleChange}
									rules={accommodationRequest.PANNo}
								/>
							</Col>
							<Col span={6}>
								<InputComponent
									name="seoTitle"
									label="SEO Title"
									placeholder="Enter SEO Title"
									onChange={handleChange}
									rules={accommodationRequest.seoTitle}
								/>
							</Col>
							<Col span={12}>
								<Form.Item label="FAQs">
									<FAQForm form={form} onChange={handleChange} />
									{/* <QuillEditor
									value={faQsValue}
									onChange={onFaqChange}
									height="207px"
								/> */}
								</Form.Item>
							</Col>
							<Col span={12}>
								<InputComponent
									type={'textarea'}
									name="faQsSchema"
									label="FAQs Schema"
									placeholder="FAQs Schema"
									onChange={handleChange}
									rules={accommodationRequest.faQsSchema}
									rows={9}
								/>
							</Col>
						</Row>
					</Col>
				</Col>

				{/* <Divider>Property Setting</Divider>
				<Col span={8}>
					<InputComponent
						required
						name="settingKey"
						label="Property SettingKey"
						placeholder="Enter Property SettingKey"
						onChange={handleChange}
						rules={accommodationRequest.settingKey}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						name="settingName"
						label="Property SettingName"
						placeholder="Enter Property SettingName"
						onChange={handleChange}
						rules={accommodationRequest.settingKey}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						name="settingValue"
						label="Property SettingValue"
						placeholder="Enter Property SettingValue"
						onChange={handleChange}
						rules={accommodationRequest.settingKey}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						required
						name="defaultValue"
						label="Property DefaultValue"
						placeholder="Enter Property DefaultValue"
						onChange={handleChange}
						rules={accommodationRequest.defaultValue}
					/>
				</Col>
				<Col span={8}>
					<InputComponent
						name="settingdbType"
						label="Property SettingdbType"
						placeholder="Enter Property SettingdbType"
						onChange={handleChange}
						rules={accommodationRequest.settingdbType}
					/>
				</Col> */}
			</Row>
		</Form>
	);
});

export default PropertyComponent;
